<template>
  <div class="group-videos container">
    <div class="columns is-multiline">
      <collection-item v-for="item in items" :item="item" :key="item.id"></collection-item>
    </div>
</div>
</template>

<script>
import CollectionItem from "@/components/series/CollectionItem.vue";

export default {
  name: `CollectionList`,
  props: {
    items: Array
  },
  components: {
    CollectionItem
  }
};
</script>

<style>
</style>
